import React from 'react';
import { useSelector } from 'react-redux';
import { RootStore } from 'store/types';
import { TitlePolicyPage } from './TitlePolicyPage';
import {
  isCommitmentName,
  isLongFormLendersPolicyName,
  isOwnersPolicyName,
  isShortFormLendersPolicyName,
} from '../../../../types/order/documents/IDocumentCategoryType';
import { IStandardDocumentVersionData } from '../../../../types/order/documents/shared/interfaces';
import { Card, PageLoading } from '../../../../ui-toolkit';
import { useParams } from 'react-router-dom';
import { UUID } from '../../../../types/shared/UUID';

export const findDocumentByCategory = (
  utilFunction: (name: string) => boolean,
  docs?: IStandardDocumentVersionData[]
): IStandardDocumentVersionData | undefined => {
  if (!docs) return undefined;
  return docs.find(({ category }) => utilFunction(category));
};

export const TitlePolicyContainer: React.FC = () => {
  const { orderId } = useParams<{ orderId: UUID }>();

  const { documents, documentsFetchStatus } = useSelector(({ order }: RootStore) => order.documents.adminDocuments);

  const commitmentDocument = findDocumentByCategory(isCommitmentName, documents[orderId]);
  const ownerPolicy = findDocumentByCategory(isOwnersPolicyName, documents[orderId]);
  const longFormPolicy = findDocumentByCategory(isLongFormLendersPolicyName, documents[orderId]);
  const shortFormPolicy = findDocumentByCategory(isShortFormLendersPolicyName, documents[orderId]);

  return (
    <PageLoading isLoading={documentsFetchStatus.fetching}>
      <Card title={'Title Policy'}>
        <TitlePolicyPage
          isCommitmentGenerated={!!commitmentDocument}
          ownerPolicy={ownerPolicy}
          longFormPolicy={longFormPolicy}
          shortFormPolicy={shortFormPolicy}
        />
      </Card>
    </PageLoading>
  );
};
